<template>
  <section>
    <div class="row">
      <div class="col-md-3 text-center">
        <img src="/media/measurements_guide.png" width="150" />
      </div>
      <div class="col-md-9">
        <table class="custom-table">
          <tr>
            <th></th>
            <th v-for="(item, idx) of selected" :key="idx" class="text-center">
              {{ item.date }}
            </th>
          </tr>
          <tr>
            <th></th>
            <th colspan="3" class="custom-inches">inches</th>
          </tr>
          <tr>
            <td>
              <table class="custom-table">
                <tr v-for="row of rows" :key="row.id" class="custom-row">
                  <td>
                    <span class="badge rounded-pill custom-pill">{{
                      row.id
                    }}</span>
                  </td>
                  <td>
                    <span class="custom-name">{{ row.name }}</span>
                  </td>
                </tr>
              </table>
            </td>
            <td v-for="(item, idx) of selected" :key="idx">
              <table class="custom-table">
                <tr v-for="row of item.rows" :key="row.id" class="custom-row">
                  <td class="text-center">{{ row.value }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import globals from '@/Plugins/globals'
export default {
  name: 'measurements',
  data() {
    return {
      rows: [
        {
          id: 1,
          name: 'Shoulder to shoulder (around backside only)',
          value: 0,
        },
        {
          id: 2,
          name: 'Measure at fullest part of bust',
          value: 0,
        },
        {
          id: 3,
          name: 'Around arm (hand at hip)',
          value: 0,
        },
        {
          id: 4,
          name: 'Waist (at belly button)',
          value: 0,
        },
        {
          id: 5,
          name: 'Measure around fullest part of hips',
          value: 0,
        },
        {
          id: 6,
          name: 'Thigh',
          value: 0,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('measurements', ['measurements']),
    selected() {
      let _data = []
      this.measurements.forEach((element) => {
        let _rows = JSON.parse(JSON.stringify(this.rows))
        _rows.forEach((row) => {
          switch (row.id) {
            case 1: {
              row.value = element.shoulder
              break
            }
            case 2: {
              row.value = element.bust
              break
            }
            case 3: {
              row.value = element.arm
              break
            }
            case 4: {
              row.value = element.waist
              break
            }
            case 5: {
              row.value = element.hips
              break
            }
            case 6: {
              row.value = element.thigh
              break
            }
          }
        })
        if (element.checked) {
          _data.push({
            date: element.date,
            rows: globals.sortArray(_rows, 'measurement_date', 'desc'),
          })
        }
      })
      return _data
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-table {
  width: 100%;
}
.custom-row {
  height: 42px;
}
.custom-name {
  padding: 10px;
}
.custom-pill {
  color: rgb(197, 128, 0);
  background-color: #c4c4c4 !important;
}
.custom-inches {
  text-align: center;
  font-size: 0.8em;
  font-weight: 400;
}
</style>
